export default __webpack_public_path__ + "static/media/teaser2small.8d6056d5.jpg";